<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">{{ dynamicLabel }}</v-card-title>
        <v-card-text v-if="!readonly">
          <div class="d-flex align-center">
            <v-btn class="mr-2" color="primary" @click="clickAddNewLine()"><v-icon left>mdi-plus</v-icon>Selecionar Linha</v-btn>
            <v-btn v-if="(groupUser === 1 || groupUser === 2) && page === 'wizard'" color="success" @click="showModalImport = true"><v-icon left>mdi-database-import</v-icon>Importar arquivo</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      sm="6"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass">
            {{lineSelected && lineSelected.ddi ? lineSelected.ddi+' ('+lineSelected.ddd+') '+lineSelected.nr_linha : 'Selecione uma linha' }}
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="!readonly && lineSelect.length > 1" icon @click="closeLine(index)" class="mx-3 mt-2 white--text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <LineComponent
                :readonly="readonly"
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                :selectedLine="lineSelected"
                :searchParams="{
                  'id_operadora': CONST_CLARO
                }"
                @save="
                  lineSelected = $event;
                  updateSelectedLine($event, index);
                "
              ></LineComponent>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <ImportDataSolicitationDialogComponent
      v-if="showModalImport"
      :title="'Linhas Identificadas'"
      :automation=CONST_RESET_LINE
      @closeDialog="showModalImport = false"
      @importValues="importValues($event)"
    ></ImportDataSolicitationDialogComponent>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import LineComponent from "@/components/forms/LineComponent.vue";
import ImportDataSolicitationDialogComponent from "@/components/dialog/ImportDataSolicitationDialogComponent.vue";
import isEmpty from "lodash/isEmpty";
import { AUTOMATION_RESET_LINE, CLARO } from "../../helpers/constants";
export default {
  components: { LineComponent, ImportDataSolicitationDialogComponent },
  props: {
    index: {},
    groupUser: {},
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultValues: {
      type: Array,
      default: () => []
    },
    field: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      lineSelect: [],
      loading: true,
      show: false,
      maxLength: 50,
      showModalImport: false,
      dynamicLabel: "Reset Linha",
      resultStorage: null,
      lineRules: [v => !!v || "Linha é obrigatório"],
    };
  },
  async mounted() {
    if (this.page === 'interaction') {
      this.readonly = true;
      this.lineSelect = this.field.lines;
      await this.updateValues();
    }
    if (this.page === 'validate') {
      this.$emit('componentLoading', true);
    }

    if (this.page === 'wizard') {
      if (this.wizard.model["reset_line"]) {
        this.wizard.forms.map(form => {
          if (form.type === "reset_line") {
            this.dynamicLabel = form.label;
          }
        });
      }

      this.lineSelect = [...this.lineSelect, {}];

      const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
      if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
        this.resultStorage = dataLocalStorage;
        this.lineSelect = Object.assign([], this.resultStorage);
      }
    }

    if (this.defaultValues.length > 0) {
      this.lineSelect = this.defaultValues;
    }

    if (this.page === 'validate') {
      await this.updateValues();
      this.$emit('componentLoading', false);
    }
    this.loading = false;
  },
  computed: {
    CONST_RESET_LINE() {
      return AUTOMATION_RESET_LINE;
    },
    CONST_CLARO() {
      return CLARO;
    },
    ...mapState("packages", ["lines"]),
    ...mapState("forms", ["wizard"]),
    ...mapState("solicitation", ["solicitation_validate_values"]),
  },
  methods: {
    ...mapActions("solicitation", ["loadDataLocalStorage","setAutomationComponentValues"]),
    ...mapActions("interaction", ["setAutomationComponentFields"]),
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapMutations({setModel: "forms/setModelResetLine"}),
    async clickAddNewLine() {
      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        this.lineSelect = [{}, ...this.lineSelect];
      }
    },
    importValues(data) {
      const existingIds = new Set(this.lineSelect.map(item => item.id_linha));
      const filtered = data.filter(
        item => !existingIds.has(item.id_linha)
      );

      this.lineSelect.push(...filtered);
      this.updateValues(this.lineSelect);
      this.showModalImport = false;
    },
    async updateSelectedLine(lineSelected, index) {
      const exists = this.lineSelect.some((line, i) => line.id_linha === lineSelected.id_linha && i !== index);

      if (exists) {
        this.lineSelect[index] = [];
        this.lineSelect = Object.assign([], this.lineSelect);
        await this.$swal("Linha já selecionada!", "", "warning");
        return;
      }

      this.lineSelect[index] = lineSelected;
      this.lineSelect = Object.assign([], this.lineSelect);
      await this.updateValues(this.lineSelect);
    },
    async updateValues(lineList) {
      if (this.page === 'validate') {
        await this.setAutomationComponentValues({
          automation: "reset_line",
          data: { reset_line: this.lineSelect }
        });
        this.SET_FORM_EMAIL({});
        this.SET_FORM_EMAIL(this.solicitation_validate_values);

      } else if (this.page === 'wizard') {
        const payload = {
          step: this.index,
          selected: lineList
        };
        this.setModel(payload);
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(lineList));
      } else if (this.page === 'interaction'){
        await this.setAutomationComponentFields({
          automation: "reset_line",
          data: this.lineSelect,
        });
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
      }
      this.updateValues(this.lineSelect);
    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
